(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-battery-promise"]) return;
  try {
    
(function () {
  function cfg() { var el = document.querySelector('[data-tsbp]'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function line(html) { var p = document.createElement('p'); p.className = 'tsbp'; p.innerHTML = '<span class="tsbp__i" aria-hidden="true"><svg class="ts-i" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="7.5" width="16" height="9" rx="2"/><path d="M21.5 11v2"/><path d="M5.5 10.5h6v3h-6z"/></svg></span><span></span>'; p.lastChild.innerHTML = html; return p; }
  function text(c, grade) { var g = (grade || '').trim().toLowerCase(); if (g === 'brand new') return c.new; if (g === 'excellent') return c.excellent; return c.other; }
  function init() {
    var c = cfg(); if (!c) return;
    var opt = document.querySelector('[data-ts-pdp] [data-ts-option][data-name="Condition"]');
    if (opt && !opt.nextElementSibling?.classList.contains('tsbp')) {
      var p = line(''); opt.after(p);
      var upd = function () { var ch = opt.querySelector('[data-ts-chosen]'); p.lastChild.innerHTML = text(c, ch ? ch.textContent : ''); };
      document.querySelector('[data-ts-pdp]').addEventListener('click', function () { setTimeout(upd, 0); }); upd();
    }
    var gr = document.querySelector('.tsm2-grades');
    if (gr && !gr.nextElementSibling?.classList.contains('tsbp')) gr.after(line(c.all));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-battery"]) return;
  try {
    
(function () {
  function init() {
    var info = document.querySelector('[data-ts-batt-info]'); var tpl = document.querySelector('[data-ts-batt-tpl]');
    var pdp = document.querySelector('[data-ts-pdp]'); if (!info || !tpl || !pdp) return;
    var form = pdp.querySelector('[data-ts-form]'); if (!form || pdp.querySelector('[data-ts-batt-row]')) return;
    var data = JSON.parse(info.textContent); var skip = (data.skip || []).map(function (s) { return s.trim().toLowerCase(); });
    var variants = JSON.parse(pdp.querySelector('[data-ts-variants]').textContent);
    var row = tpl.content.firstElementChild.cloneNode(true); var box = row.querySelector('[data-ts-batt]');
    var chosen = row.querySelector('[data-ts-batt-chosen]');
    // sits with the other choices: straight after the Condition row (or before the buy buttons)
    var cond = pdp.querySelector('[data-ts-option][data-name="Condition"]');
    var promise = cond && cond.nextElementSibling && cond.nextElementSibling.classList.contains('tsbp') ? cond.nextElementSibling : cond;
    if (promise) promise.after(row); else form.insertBefore(row, form.querySelector('.ts-buy__row'));
    var idInput = form.querySelector('[data-ts-variant-id]');
    function paint() {
      row.querySelectorAll('[data-ts-batt-pick]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-ts-batt-pick') === '1') === box.checked)); });
      chosen.textContent = box.checked ? data.new : data.std;
      var pay = form.querySelector('.shopify-payment-button'); if (pay) pay.hidden = box.checked;
      var buynow = pdp.querySelector('.ts-buynow'); if (buynow) buynow.hidden = box.checked;
    }
    function update() {
      var v = variants.find(function (x) { return String(x.id) === idInput.value; });
      var preowned = v && !v.options.some(function (o) { return skip.indexOf(String(o).toLowerCase()) > -1; });
      row.hidden = !preowned; if (!preowned) box.checked = false;
      paint();
    }
    row.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ts-batt-pick]'); if (!b) return;
      box.checked = b.getAttribute('data-ts-batt-pick') === '1'; paint();
    });
    pdp.addEventListener('click', function (e) { if (!e.target.closest('[data-ts-batt-row]')) setTimeout(update, 0); });
    form.addEventListener('submit', function (e) {
      if (!box.checked || row.hidden) return;
      e.preventDefault();
      var qty = parseInt((form.querySelector('[data-ts-qty]') || {}).value, 10) || 1;
      var v = variants.find(function (x) { return String(x.id) === idInput.value; });
      var btn = form.querySelector('[data-ts-add]'); if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: qty },
          { id: Number(data.variant), quantity: qty, properties: { 'For': data.title + (v ? ' – ' + v.options.join(' / ') : '') } }] }) })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; } alert('Sorry, that could not be added. Please try again.'); });
    }, true);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-catbar"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Desktop dressing only. Everything below moves or adds OUR OWN elements; the theme's menu is never touched.
  var mq = window.matchMedia('(min-width: 990px)');
  function dress() {
    var bar = document.querySelector('[data-tscb]');
    if (!bar || bar.dataset.desktop !== 'true' || !mq.matches) return;
    var hdr = document.getElementById('header-component'); if (!hdr) return;
    var left = hdr.querySelector('.header__column--left'), right = hdr.querySelector('.header__column--right');
    if (!left || !right) return;
    document.documentElement.dataset.tsHdr = '1';
    var form = bar.querySelector('.tscb__search');
    if (form && !hdr.querySelector('.ts-hdr-search')) {
      var w = document.createElement('div'); w.className = 'ts-hdr-search'; w.appendChild(form); left.appendChild(w);
    }
    if (!hdr.querySelector('.ts-hdr-acts')) {
      var acts = document.createElement('div'); acts.className = 'ts-hdr-acts';
      if (bar.dataset.sell) {
        var s1 = document.createElement('a'); s1.className = 'ts-hdr-sell'; s1.href = bar.dataset.sell;
        s1.textContent = bar.dataset.sellText || 'Sell your device'; acts.appendChild(s1);
      }
      if (bar.dataset.repair) {
        var s2 = document.createElement('a'); s2.className = 'ts-hdr-rep'; s2.href = bar.dataset.repair;
        s2.textContent = bar.dataset.repairText || 'Repairs'; acts.appendChild(s2);
      }
      if (acts.children.length) right.insertBefore(acts, right.firstChild);
    }
    bar.classList.add('tscb--moved');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dress); else dress();
  // the theme re-renders its header on some page updates: put our own bits back if they went with it
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(dress, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
  (mq.addEventListener || function (n, f) { mq.addListener(f); }).call(mq, 'change', function () { location.reload(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-collection-grid"]) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var form = root.querySelector('[data-tsg-form]');
    root.querySelectorAll('[data-tsg-auto]').forEach(function (el) { el.addEventListener('change', function () { form.submit(); }); });
    var wide = window.matchMedia('(min-width: 990px)');
    var btn = root.querySelector('[data-tsg-toggle]');
    function pref(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
    if (pref('tsg-side') === 'closed' && wide.matches) { root.classList.add('no-side'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function () {
      if (wide.matches) { var closed = root.classList.toggle('no-side'); btn.setAttribute('aria-expanded', String(!closed)); pref('tsg-side', closed ? 'closed' : 'open'); }
      else { var open = root.classList.toggle('side-open'); btn.setAttribute('aria-expanded', String(open)); }
    });
    var views = root.querySelectorAll('[data-tsg-view]');
    function setView(v) { root.classList.toggle('is-list', v === 'list'); views.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tsg-view') === v)); }); pref('tsg-view', v); }
    views.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-tsg-view')); }); });
    if (pref('tsg-view') === 'list') setView('list');
    form.addEventListener('submit', function () { form.querySelectorAll('.tsg-price input').forEach(function (i) { if (!i.value) i.disabled = true; }); });
  }
  function all() { document.querySelectorAll('[data-tsg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-colour-photos"]) return;
  try {
    
(function () {
  function init() {
    var pdp = document.querySelector('[data-ts-pdp]'); if (!pdp || pdp.dataset.tsColour) return;
    var strip = pdp.querySelector('[data-ts-thumbs]'); if (!strip) return;
    pdp.dataset.tsColour = '1';
    var thumbs = Array.prototype.slice.call(strip.querySelectorAll('[data-ts-thumb]'));
    if (thumbs.length < 2) return;
    var opt = pdp.querySelector('[data-ts-option][data-name="Colour"], [data-ts-option][data-name="Color"]');
    function colour() { var c = opt && opt.querySelector('[data-ts-chosen]'); return c ? c.textContent.trim().toLowerCase() : ''; }
    function visible() { return thumbs.filter(function (t) { return !t.classList.contains('ts-thumb--off'); }); }
    function active() { var v = visible(); var i = v.findIndex(function (t) { return t.classList.contains('is-active'); }); return { list: v, i: i }; }
    function filtering() { return thumbs.some(function (t) { return t.classList.contains('ts-thumb--off'); }); }
    function apply() {
      var c = colour();
      var match = c ? thumbs.filter(function (t) { return (t.getAttribute('data-alt') || '').toLowerCase().indexOf(c) > -1; }) : [];
      thumbs.forEach(function (t) { t.classList.toggle('ts-thumb--off', match.length > 0 && match.indexOf(t) === -1); });
      var a = active();
      if (a.i === -1 && a.list.length) a.list[0].click();
      fixCount();
    }
    function go(d) { var a = active(); if (!a.list.length) return; var n = (Math.max(a.i, 0) + d + a.list.length) % a.list.length; a.list[n].click(); setTimeout(fixCount, 30); }
    function fixCount() {
      var el = document.querySelector('.ts-lb__count'); if (!el || !filtering()) return;
      var a = active(); if (a.list.length > 1 && a.i > -1) el.textContent = (a.i + 1) + ' / ' + a.list.length;
    }
    // arrows (page and full-screen) move within the visible photos only
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ts-nav], .ts-lb__nav'); if (!b || !filtering()) return;
      e.stopImmediatePropagation(); e.preventDefault();
      go(b.classList.contains('ts-gallery__nav--prev') || b.classList.contains('ts-lb__nav--prev') ? -1 : 1);
    }, true);
    // swiping too
    var sx = null, swipedAt = 0;
    function onStart(e) { sx = e.touches[0].clientX; }
    function onEnd(e) {
      if (sx === null || !filtering()) { sx = null; return; }
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 45) { e.stopImmediatePropagation(); swipedAt = Date.now(); go(dx < 0 ? 1 : -1); }
    }
    var zoom = pdp.querySelector('[data-ts-zoom]');
    if (zoom) {
      zoom.addEventListener('touchstart', onStart, { capture: true, passive: true });
      zoom.addEventListener('touchend', onEnd, { capture: true, passive: false });
      zoom.addEventListener('click', function (e) { if (Date.now() - swipedAt < 500) { e.stopImmediatePropagation(); e.preventDefault(); } }, true);
    }
    document.addEventListener('touchstart', function (e) { if (e.target.closest('.ts-lb')) onStart(e); }, { capture: true, passive: true });
    document.addEventListener('touchend', function (e) { if (e.target.closest('.ts-lb')) onEnd(e); }, { capture: true, passive: false });
    document.addEventListener('keydown', function (e) {
      var lb = document.querySelector('.ts-lb'); if (!lb || lb.hidden || !filtering()) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.stopImmediatePropagation(); go(e.key === 'ArrowLeft' ? -1 : 1); }
    }, true);
    // colour changed (the page script updates the chosen colour first, then we filter)
    pdp.addEventListener('click', function (e) { if (e.target.closest('[data-ts-option]')) setTimeout(apply, 0); });
    document.addEventListener('click', function () { setTimeout(fixCount, 60); });
    apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-deal"] && !Shopify.designMode) return;
  try {
    
(function () {
  function tick(root) {
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Pacific/Auckland' }));
    var end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    function two(n) { return (n < 10 ? '0' : '') + n; }
    root.querySelector('[data-h]').textContent = two(Math.floor(s / 3600));
    root.querySelector('[data-m]').textContent = two(Math.floor(s % 3600 / 60));
    root.querySelector('[data-s]').textContent = two(s % 60);
  }
  function init() { document.querySelectorAll('[data-ts-deal-clock]').forEach(function (c) { if (c.dataset.on) return; c.dataset.on = '1'; tick(c); setInterval(function () { tick(c); }, 1000); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-glide"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.ts-carousel__track, .ts-series, .ts-grid';
  var rows = [];
  function speed() { var s = document.querySelector('[data-ts-glide-speed]'); return s ? parseFloat(s.getAttribute('data-ts-glide-speed')) || 28 : 28; }
  function setup(el) {
    if (el.dataset.glide) return;
    var kids = Array.prototype.slice.call(el.children);
    if (kids.length < 3 || el.scrollWidth <= el.clientWidth + 20) return; // fits already: no need to move
    el.dataset.glide = '1';
    kids.forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('data-ts-clone', ''); c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a,button,input').forEach(function (a) { a.tabIndex = -1; }); el.appendChild(c); });
    el.classList.add('ts-glide');
    var row = { el: el, half: 0, paused: false, pos: el.scrollLeft, resume: 0 };
    function measure() { var first = el.children[kids.length]; row.half = first ? first.offsetLeft - el.children[0].offsetLeft : el.scrollWidth / 2; }
    measure(); window.addEventListener('resize', measure);
    function hold() { row.paused = true; }
    function free() { row.paused = false; row.pos = el.scrollLeft; }
    el.addEventListener('mouseenter', hold); el.addEventListener('mouseleave', free);
    el.addEventListener('focusin', hold); el.addEventListener('focusout', free);
    el.addEventListener('touchstart', hold, { passive: true });
    el.addEventListener('touchend', function () { row.resume = performance.now() + 2500; }, { passive: true });
    el.addEventListener('scroll', function () { if (row.paused) row.pos = el.scrollLeft; }, { passive: true });
    var car = el.closest('[data-ts-carousel]');
    if (car) car.querySelectorAll('[data-ts-car-prev],[data-ts-car-next]').forEach(function (b) { b.addEventListener('click', function () { row.paused = true; row.resume = performance.now() + 4000; }); });
    rows.push(row);
  }
  var last = 0, visible = true, px = speed();
  function frame(t) {
    var dt = last ? Math.min(64, t - last) / 1000 : 0; last = t;
    if (visible) rows.forEach(function (r) {
      if (r.resume && t > r.resume) { r.resume = 0; r.paused = false; r.pos = r.el.scrollLeft; }
      if (r.paused || !r.half) return;
      var box = r.el.getBoundingClientRect(); if (box.bottom < 0 || box.top > window.innerHeight) return;
      r.pos += px * dt; if (r.pos >= r.half) r.pos -= r.half;
      r.el.scrollLeft = r.pos;
    });
    requestAnimationFrame(frame);
  }
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; last = 0; });
  function start() { px = speed(); document.querySelectorAll(SEL).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
  requestAnimationFrame(frame);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-google-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FIELDS = 'rating,userRatingCount,googleMapsUri,reviews';
  function safeUrl(u) { return typeof u === 'string' && /^https:\/\//.test(u) ? u : ''; }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function stars(r) { var n = Math.max(0, Math.min(5, Math.round(r || 0))); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
  function card(rv) {
    var a = rv.authorAttribution || {};
    var c = el('article', 'tsr-card');
    var top = el('div', 'tsr-card__top');
    var img = el('img', 'tsr-card__img');
    img.alt = ''; img.loading = 'lazy'; img.referrerPolicy = 'no-referrer'; img.width = 38; img.height = 38;
    if (safeUrl(a.photoUri)) img.src = a.photoUri;
    top.appendChild(img);
    var who = el('div', 'tsr-card__who');
    var name = el(safeUrl(a.uri) ? 'a' : 'span', 'tsr-card__name', a.displayName || 'Google user');
    if (safeUrl(a.uri)) { name.href = a.uri; name.target = '_blank'; name.rel = 'noopener nofollow'; }
    who.appendChild(name);
    var meta = el('span', 'tsr-card__when');
    meta.appendChild(el('span', 'tsr-stars', stars(rv.rating)));
    meta.appendChild(document.createTextNode(' ' + (rv.relativePublishTimeDescription || '')));
    who.appendChild(meta);
    top.appendChild(who);
    c.appendChild(top);
    var t = (rv.text && rv.text.text) || (rv.originalText && rv.originalText.text) || '';
    c.appendChild(el('p', 'tsr-card__text', t));
    var foot = el('div', 'tsr-card__foot');
    var left = el('span', 'tsr-attr', 'Google Maps');
    foot.appendChild(left);
    var translated = rv.text && rv.originalText && rv.text.languageCode && rv.originalText.languageCode &&
      rv.text.languageCode !== rv.originalText.languageCode;
    if (translated) foot.appendChild(el('span', 'tsr-card__tr', 'Translated by Google'));
    if (safeUrl(rv.googleMapsUri)) {
      var link = el('a', '', 'View on Google Maps'); link.href = rv.googleMapsUri; link.target = '_blank'; link.rel = 'noopener nofollow';
      foot.appendChild(link);
    }
    c.appendChild(foot);
    return c;
  }
  function render(root, d) {
    var list = (d.reviews || []).filter(function (r) { return r && ((r.text && r.text.text) || (r.originalText && r.originalText.text)); });
    if (!list.length) return;
    var track = root.querySelector('[data-tsr-track]');
    track.textContent = '';
    for (var round = 0; round < 2; round++) {
      list.forEach(function (rv) { var c = card(rv); if (round) { c.setAttribute('aria-hidden', 'true'); c.setAttribute('data-copy', ''); c.querySelectorAll('a').forEach(function (x) { x.tabIndex = -1; }); } track.appendChild(c); });
    }
    track.style.setProperty('--tsr-dur', (list.length * 9) + 's');
    if (d.rating) {
      root.querySelector('[data-tsr-score]').textContent = Number(d.rating).toFixed(1);
      root.querySelector('[data-tsr-stars]').textContent = stars(d.rating);
      root.querySelector('[data-tsr-count]').textContent = d.userRatingCount ? d.userRatingCount + ' Google reviews' : 'on Google';
      root.querySelector('[data-tsr-sum]').hidden = false;
    }
    var all = root.querySelector('[data-tsr-all]'); if (all && safeUrl(d.googleMapsUri)) all.href = d.googleMapsUri;
    root.querySelector('[data-tsr-live]').hidden = false;
    root.querySelector('[data-tsr-fallback]').hidden = true;
  }
  function load(root) {
    var key = root.getAttribute('data-key'), place = root.getAttribute('data-place');
    if (!key || !place || !window.fetch) return;
    fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(place) + '?languageCode=en', {
      headers: { 'X-Goog-Api-Key': key, 'X-Goog-FieldMask': FIELDS }
    }).then(function (r) { if (!r.ok) throw new Error('Google ' + r.status); return r.json(); })
      .then(function (d) { render(root, d); })
      .catch(function () { /* keep the simple 'Read our Google reviews' banner */ });
  }
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(root); } }, { rootMargin: '300px' });
      io.observe(root);
    } else load(root);
  }
  function all() { document.querySelectorAll('[data-tsr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-menu"]) return;
  try {
    
(function () {
  var cache = {};
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)\/?$/); return m ? m[1] : null; }
  function load(h) {
    if (!cache[h]) {
      cache[h] = fetch(root() + 'collections/' + h + '?section_id=techsite-menu-products')
        .then(function (r) { if (!r.ok) throw new Error('menu'); return r.text(); })
        .then(function (t) { var d = document.createElement('div'); d.innerHTML = t; var p = d.querySelector('.tsm-panel'); return p ? p.outerHTML : ''; })
        .catch(function (e) { delete cache[h]; throw e; });
    }
    return cache[h];
  }
  function setup(grid) {
    if (grid.dataset.tsm || grid.dataset.tsmFailed) return;
    var orig = grid.querySelector('.mega-menu__content:not(.tsm)'); if (!orig) return;
    var links = Array.prototype.filter.call(grid.querySelectorAll('.mega-menu__link'), function (a) { return handleOf(a); });
    if (!links.length) return;
    grid.dataset.tsm = '1';
    var old = grid.querySelector('.tsm'); if (old) old.remove();
    var panel = document.createElement('div');
    panel.className = 'mega-menu__content tsm tsm-off';
    orig.parentNode.insertBefore(panel, orig.nextSibling);
    var timer = null, cur = null, first = links[0];
    function fallback() { cur = null; panel.classList.add('tsm-off'); orig.classList.remove('tsm-off'); delete grid.dataset.tsm; grid.dataset.tsmFailed = '1'; }
    function show(a, quiet) {
      var h = handleOf(a); if (cur === h) return; cur = h;
      grid.querySelectorAll('.is-tsm').forEach(function (x) { x.classList.remove('is-tsm'); });
      if (!quiet) a.classList.add('is-tsm');
      panel.classList.add('tsm-loading');
      load(h).then(function (html) {
        if (cur !== h) return;
        if (!html) { if (quiet) fallback(); return; }
        panel.innerHTML = html; panel.classList.remove('tsm-off', 'tsm-loading'); orig.classList.add('tsm-off');
      }).catch(function () { if (cur === h && quiet) fallback(); else panel.classList.remove('tsm-loading'); });
    }
    links.forEach(function (a) {
      a.addEventListener('mouseenter', function () { load(handleOf(a)).catch(function () {}); clearTimeout(timer); timer = setTimeout(function () { show(a); }, 110); });
      a.addEventListener('mouseleave', function () { clearTimeout(timer); });
      a.addEventListener('focus', function () { show(a); });
    });
    var menu = grid.closest('.menu-list__list-item') || grid.closest('.mega-menu') || grid;
    menu.addEventListener('mouseleave', function () { clearTimeout(timer); show(first, true); });
    show(first, true);
  }
  function gridFor(el) {
    if (!el || !el.closest) return null;
    var g = el.closest('.mega-menu__grid'); if (g) return g;
    var li = el.closest('.menu-list__list-item');
    return li ? li.querySelector('.mega-menu__grid') : null;
  }
  function onEnter(e) { var g = gridFor(e.target); if (g) setup(g); }
  document.addEventListener('pointerover', onEnter, true);
  document.addEventListener('focusin', onEnter, true);
  window.addEventListener('load', function () {
    var g = document.querySelector('.mega-menu__grid'); if (!g) return;
    var a = g.querySelector('.mega-menu__link'); var h = a && handleOf(a); if (h) setTimeout(function () { load(h).catch(function () {}); }, 800);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-payments"]) return;
  try {
    
(function () {
  function init() {
    var pdp = document.querySelector('[data-ts-pdp]'); if (!pdp || pdp.dataset.tsp) return;
    var vEl = pdp.querySelector('[data-ts-variants]'); var mEl = pdp.querySelector('[data-ts-money]'); if (!vEl || !mEl) return;
    pdp.dataset.tsp = '1';
    var variants = JSON.parse(vEl.textContent); var fmt = JSON.parse(mEl.textContent);
    var cfgEl = document.querySelector('[data-tsp-cfg]'); var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { buy: true, buyText: 'Buy now' };
    function money(c) { var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return fmt.replace(/\{\{\s*\w+\s*\}\}/, n); }
    // the price block was renamed when the product page was rebuilt; accept either name
    var price = pdp.querySelector('.ts-bb__price, .ts-price'); var t1 = document.querySelector('[data-tsp-price]');
    if (price && t1) price.parentNode.insertBefore(t1.content.cloneNode(true), price.nextSibling);
    var form = pdp.querySelector('[data-ts-form]'); var t2 = document.querySelector('[data-tsp-after-form]');
    if (form && t2) form.parentNode.insertBefore(t2.content.cloneNode(true), form.nextSibling);
    var info = pdp.querySelector('[data-tsp-ap-info]'); var how = pdp.querySelector('[data-tsp-ap-how]');
    if (info && how) info.addEventListener('click', function (e) { e.stopPropagation(); how.hidden = !how.hidden; info.setAttribute('aria-expanded', String(!how.hidden)); });
    var id = pdp.querySelector('[data-ts-variant-id]');
    function current() { return variants.find(function (x) { return id && String(x.id) === id.value; }) || variants[0]; }

    // Buy now: add (with the battery upgrade if ticked) and go straight to checkout
    var row = pdp.querySelector('.ts-buy__row'); var addBtn = pdp.querySelector('[data-ts-add]');
    if (cfg.buy && row && addBtn && !row.querySelector('[data-tsp-buy]')) {
      var buy = document.createElement('button'); buy.type = 'button'; buy.className = 'ts-buynow'; buy.setAttribute('data-tsp-buy', '');
      buy.textContent = cfg.buyText; row.appendChild(buy); row.classList.add('has-buynow');
      var err = document.createElement('p'); err.className = 'tsp-err'; err.hidden = true; row.parentNode.insertBefore(err, row.nextSibling);
      var sync = function () { buy.disabled = addBtn.disabled; buy.textContent = addBtn.disabled ? 'Sold out' : cfg.buyText; };
      new MutationObserver(sync).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] }); sync();
      buy.addEventListener('click', function () {
        if (buy.disabled) return; err.hidden = true;
        var qty = parseInt((pdp.querySelector('[data-ts-qty]') || {}).value, 10) || 1;
        var v = current(); var items = [{ id: Number(id.value), quantity: qty }];
        var bi = document.querySelector('[data-ts-batt-info]'); var box = pdp.querySelector('[data-ts-batt]'); var brow = pdp.querySelector('[data-ts-batt-row]');
        if (bi && box && box.checked && brow && !brow.hidden) {
          var d = JSON.parse(bi.textContent);
          items.push({ id: Number(d.variant), quantity: qty, properties: { 'For': d.title + (v ? ' – ' + v.options.join(' / ') : '') } });
        }
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        buy.disabled = true; buy.textContent = 'Going to checkout…';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = root + 'checkout'; })
          .catch(function () { sync(); err.textContent = 'Sorry, that could not be added – please try again or use Add to cart.'; err.hidden = false; });
      });
    }

    function upd() {
      var ap = pdp.querySelector('[data-tsp-ap]'); if (!ap) return;
      var v = current(); if (!v) return;
      var max = parseInt(ap.getAttribute('data-max'), 10) || 0; var ok = !max || v.price <= max;
      var over = pdp.querySelector('[data-tsp-ap-over]');
      ap.hidden = !ok; if (over) over.hidden = ok;
      ap.querySelector('[data-tsp-ap-amt]').textContent = money(Math.round(v.price / 4));
    }
    pdp.addEventListener('click', function () { setTimeout(upd, 0); });
    upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-product-extras"]) return;
  try {
    
(function () {
  function init() {
    var pdp = document.querySelector('[data-ts-pdp]'); var vEl = document.querySelector('[data-tsx-variants]');
    if (!pdp || !vEl || pdp.dataset.tsx) return; pdp.dataset.tsx = '1';
    var variants = JSON.parse(vEl.textContent); var info = JSON.parse(document.querySelector('[data-tsx-info]').textContent);
    var fmt = info.money;
    function money(c) { var n = (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); return fmt.replace(/\{\{\s*\w+\s*\}\}/, n); }
    function put(sel, where, ref) { var t = document.querySelector(sel); if (!t || !ref) return null; var n = t.content.firstElementChild ? t.content.cloneNode(true) : null; if (!n) return null; var first = n.firstElementChild; if (where === 'before') ref.parentNode.insertBefore(n, ref); else ref.parentNode.insertBefore(n, ref.nextSibling); return first; }
    // the title block and price block were renamed when the product page was rebuilt; accept either name
    var head = pdp.querySelector('.ts-head, .ts-info__head'); var price = pdp.querySelector('.ts-bb__price, .ts-price'); var form = pdp.querySelector('[data-ts-form]');
    put('[data-tsx-top]', 'before', head); put('[data-tsx-under-price]', 'after', price);
    var tpl = document.querySelector('[data-tsx-before-form]'); if (tpl && form) form.parentNode.insertBefore(tpl.content.cloneNode(true), form);
    var idInput = pdp.querySelector('[data-ts-variant-id]');
    // estimated delivery (shipping policy): dispatch in 1-3 business days + delivery in 2-4 business days = 3-7 business days from today (NZ time)
    var eta = pdp.querySelector('[data-tsx-eta]');
    if (eta) {
      var nz = new Date(new Date().toLocaleString('en-US', { timeZone: 'Pacific/Auckland' }));
      function add(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
      var f = function (d) { return d.toLocaleDateString('en-NZ', { weekday: 'short', day: 'numeric', month: 'short' }); };
      eta.textContent = f(add(nz, 3)) + ' – ' + f(add(nz, 7));
    }
    function upd() {
      var v = variants.find(function (x) { return String(x.id) === (idInput && idInput.value); }) || variants[0]; if (!v) return;
      var cond = info.condIndex > -1 ? v.options[info.condIndex] : '';
      var pill = pdp.querySelector('[data-tsx-pill]');
      if (pill) pill.textContent = /brand new/i.test(cond) ? 'Brand new' : /open box/i.test(cond) ? 'Open box' : 'Pre-owned';
      var st = pdp.querySelector('[data-tsx-stock]');
      if (st) st.textContent = !v.available ? 'Sold out' : (v.tracked ? v.qty + ' in stock' : 'In stock');
      var sku = pdp.querySelector('[data-tsx-sku]'); if (sku) sku.textContent = v.sku || '—';
      var gr = pdp.querySelector('[data-tsx-grade]'); if (gr) gr.textContent = cond || '—';
      var save = pdp.querySelector('[data-tsx-save]');
      if (save) { if (v.compare > v.price) { save.hidden = false; save.textContent = 'Save ' + Math.round((v.compare - v.price) * 100 / v.compare) + '% · was ' + money(v.compare); } else save.hidden = true; }
      var sp = document.querySelector('[data-tsx-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var sb = document.querySelector('[data-tsx-sticky-add]'); if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    }
    pdp.addEventListener('click', function () { setTimeout(upd, 0); }); upd();
    // tabs
    var tabs = document.querySelector('[data-tsx-tabs]');
    if (tabs) tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (!b) return;
      tabs.querySelectorAll('[data-tab]').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
      tabs.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== b.getAttribute('data-tab'); }); });
    // sticky add-to-cart once the main button scrolls away
    var sticky = document.querySelector('[data-tsx-sticky]'); var addBtn = pdp.querySelector('[data-ts-add]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; }); }).observe(addBtn);
      document.querySelector('[data-tsx-sticky-add]').addEventListener('click', function () { if (addBtn.disabled) return; if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-product-options"]) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var grid = root.querySelector('[data-tsm2-grid]'); if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.tsl'));
    var sels = Array.prototype.slice.call(root.querySelectorAll('[data-tsm2-opt]'));
    var sort = root.querySelector('[data-tsm2-sort]');
    var count = root.querySelector('[data-tsm2-count]');
    var none = root.querySelector('[data-tsm2-none]');
    var grades = Array.prototype.slice.call(root.querySelectorAll('[data-grade]'));
    var condSel = sels.find(function (s) { return /condition/i.test(s.getAttribute('aria-label')); });
    function apply() {
      var n = 0;
      items.forEach(function (it) {
        var ok = sels.every(function (s) { return !s.value || it.getAttribute('data-o' + s.getAttribute('data-tsm2-opt')) === s.value; });
        it.hidden = !ok; if (ok) n++;
      });
      var mode = sort ? sort.value : 'price-asc';
      items.slice().sort(function (a, b) {
        if (mode === 'batt-desc') return (+b.dataset.batt || 0) - (+a.dataset.batt || 0) || (+a.dataset.price - +b.dataset.price);
        var d = +a.dataset.price - +b.dataset.price; return mode === 'price-desc' ? -d : d;
      }).forEach(function (it) { grid.appendChild(it); });
      if (count) count.textContent = n;
      if (none) none.hidden = n > 0;
      grades.forEach(function (g) { g.classList.toggle('is-on', !!condSel && condSel.value === g.getAttribute('data-grade')); });
    }
    sels.forEach(function (s) { s.addEventListener('change', apply); });
    if (sort) sort.addEventListener('change', apply);
    grades.forEach(function (g) { g.addEventListener('click', function () {
      if (!condSel) return; var v = g.getAttribute('data-grade'); condSel.value = condSel.value === v ? '' : v; apply();
    }); });
    apply();
  }
  function tabs() {
    if (document.querySelector('[data-ts-pdp]')) return;
    var t = document.querySelector('[data-tsx-tabs]'); if (!t || t.dataset.tsm2) return; t.dataset.tsm2 = '1';
    t.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (!b) return;
      t.querySelectorAll('[data-tab]').forEach(function (x) { x.setAttribute('aria-selected', String(x === b)); });
      t.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== b.getAttribute('data-tab'); }); });
  }
  function all() { document.querySelectorAll('[data-tsm2]').forEach(init); tabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-sell"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ts-sell]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-ts-sell-tab]'), panels = root.querySelectorAll('[data-ts-sell-panel]');
    function show(key) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-ts-sell-tab') === key); });
      panels.forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-ts-sell-panel') !== key); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-ts-sell-tab')); }); });
    var search = root.querySelector('[data-ts-sell-search]');
    if (search) search.addEventListener('input', function () {
      var words = search.value.toLowerCase().split(/\s+/).filter(Boolean);
      panels.forEach(function (p) {
        if (words.length) p.classList.remove('is-hidden');
        p.querySelectorAll('.ts-sell__card').forEach(function (c) {
          var text = c.getAttribute('data-name') || '';
          c.classList.toggle('is-hidden', words.length > 0 && !words.every(function (w) { return text.indexOf(w) !== -1; }));
        });
      });
      if (!words.length && tabs[0]) show(tabs[0].getAttribute('data-ts-sell-tab'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.ts-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }
  function carousels() {
    document.querySelectorAll('[data-ts-carousel]').forEach(function (c) {
      if (c.dataset.ready) return; c.dataset.ready = '1';
      var t = c.querySelector('[data-ts-car-track]'), bar = c.querySelector('[data-ts-car-bar]');
      function step() { var item = t.firstElementChild; return item ? item.getBoundingClientRect().width + 18 : 300; }
      function upd() { var max = t.scrollWidth - t.clientWidth; var w = t.scrollWidth ? t.clientWidth / t.scrollWidth : 1; bar.style.width = Math.max(10, w * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (t.scrollLeft / max) * ((1 / Math.max(w, .01)) - 1) * 100 : 0) + '%)'; }
      c.querySelector('[data-ts-car-prev]').addEventListener('click', function () { t.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      c.querySelector('[data-ts-car-next]').addEventListener('click', function () { t.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      t.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }
  function all() { reveal(); carousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('[data-ts-track]'); var n = track.children.length; if (n < 2) return;
    var dots = root.querySelectorAll('[data-ts-dot]'); var i = 0, timer = null;
    var wait = parseInt(root.dataset.interval, 10) || 5000;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(k) {
      i = (k + n) % n; track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, j) { d.setAttribute('aria-selected', String(j === i)); });
      Array.prototype.forEach.call(track.children, function (s, j) { s.setAttribute('aria-hidden', String(j !== i)); s.querySelectorAll('a').forEach(function (a) { a.tabIndex = j === i ? 0 : -1; }); });
    }
    function play() { if (still) return; stop(); timer = setInterval(function () { go(i + 1); }, wait); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    root.querySelector('[data-ts-prev]').addEventListener('click', function () { go(i - 1); play(); });
    root.querySelector('[data-ts-next]').addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.tsDot, 10)); play(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; play(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    go(0); play();
  }
  document.querySelectorAll('[data-ts-slides]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ts-slides]'); if (r) init(r); });
  document.addEventListener('shopify:block:select', function (e) { var r = e.target.closest('[data-ts-slides]'); if (!r) return; var k = Array.prototype.indexOf.call(e.target.parentNode.children, e.target); var t = r.querySelector('[data-ts-track]'); if (t && k > -1) t.style.transform = 'translateX(' + (-100 * k) + '%)'; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["techsite-style"]) return;
  try {
    
(function () {
  var SVG = '<svg class="ts-kiwi" viewBox="0 0 64 44" aria-hidden="true" focusable="false"><ellipse cx="25" cy="21" rx="20" ry="14.5" fill="currentColor"/><circle cx="42" cy="14" r="6.5" fill="currentColor"/><path d="M46.5 12.5 L63 21.5 L62.2 23 L46 17.5 Z" fill="currentColor"/><circle cx="43.5" cy="12.5" r="1.1" fill="#fff"/><path d="M20 34 l-2.5 8.5 M17.5 42.5 h-4.5 M17.5 42.5 l2 1 M30 34 l1.5 8.5 M31.5 42.5 h4.5 M31.5 42.5 l-1.5 1" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" fill="none"/></svg>';
  var KIWI = '🥝';
  var COLOURS = {black:'#1d1d1f',white:'#f5f5f0',silver:'#e3e4e5',gold:'#f3d9b1','rose gold':'#e7c1b3','space gray':'#5c5c60','space grey':'#5c5c60','space black':'#2e2c2e',midnight:'#232a35',starlight:'#f0e8db',blue:'#3b6fb6',red:'#c8102e','(product)red':'#c8102e',green:'#3f6b4f',pink:'#f4c9cf',purple:'#b9a6d6','deep purple':'#4b3a52',yellow:'#f9e27c',graphite:'#4f4e4c','sierra blue':'#9bb5ce','alpine green':'#4b5a4a','pacific blue':'#2d4e5c','natural titanium':'#bfb9ae','black titanium':'#3c3b39','white titanium':'#e8e6e1','blue titanium':'#3f4a5a','desert titanium':'#c6a98c','cosmic orange':'#e5732f','deep blue':'#2a3a5e','mist blue':'#a9bfd6',lavender:'#c9bde3',sage:'#b7c2a5',ultramarine:'#5568d8',teal:'#6fa8a2','sky blue':'#bcd6ea','light gold':'#ead8b5','cloud white':'#f4f4f2',burgundy:'#6a1f2e','glacier blue':'#b9d3e6',indigo:'#3f4a8a','star white':'#f3f2ee',orange:'#f08a3c',navy:'#1f2e57',grey:'#8e8e93',gray:'#8e8e93',cream:'#efe6d2',lime:'#cfe27a',mint:'#bfe3d1',coral:'#ff7f6b','phantom black':'#1f1f1f','onyx black':'#222','marble grey':'#c9c9c9','cobalt violet':'#6a5acd','amber yellow':'#e8c25a','titanium gray':'#8a8d8f','titanium black':'#2f2f30','titanium violet':'#7d6b8f','titanium yellow':'#d9c37a','icy blue':'#b8d1e6','awesome graphite':'#4a4a4a'};
  var KEYS = [['black','#232323'],['white','#f3f2ee'],['silver','#d7d8da'],['gold','#ecd3ae'],['navy','#253553'],['blue','#5d7fa8'],['green','#7fa88c'],['red','#c0392b'],['pink','#f0c3c8'],['purple','#a995c9'],['violet','#8b7ca6'],['yellow','#f4d77d'],['orange','#f39a4a'],['gray','#8a8b8d'],['grey','#8a8b8d'],['graphite','#53524f'],['titanium','#bdb8ad']];
  function hex(name) { if (COLOURS[name]) return COLOURS[name]; var n = name.replace(/^awesome /, ''); if (COLOURS[n]) return COLOURS[n]; for (var i = 0; i < KEYS.length; i++) if (name.indexOf(KEYS[i][0]) > -1) return KEYS[i][1]; return '#c9ced8'; }
  function dots(root) { (root || document).querySelectorAll('[data-swatch]').forEach(function (d) { if (!d.dataset.done) { d.style.background = hex(d.getAttribute('data-swatch')); d.dataset.done = '1'; } }); }
  function swap(root) {
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      return n.nodeValue.indexOf(KIWI) > -1 && !(n.parentNode && /^(SCRIPT|STYLE|TEXTAREA|INPUT)$/.test(n.parentNode.nodeName)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
    var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var span = document.createElement('span');
      span.innerHTML = n.nodeValue.split(KIWI).map(function (t) { var d = document.createElement('span'); d.textContent = t; return d.innerHTML; }).join(SVG);
      n.parentNode.replaceChild(span, n);
    });
  }
  function run() { swap(document.body); dots(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { dots(document); });
  document.addEventListener('shopify:section:load', function (e) { swap(e.target); dots(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
